import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import axios from 'axios';
import { SEMANTIC, getNavStyle } from '../styles/theme';
import { useAppModal } from '../hooks/useAppModal';

const ASSET_TYPE_CFG = {
  STOCK:  { label: 'Stocks',  color: '#00aaff', icon: 'bi-bar-chart-fill' },
  ETF:    { label: 'ETF',     color: '#ffaa00', icon: 'bi-collection-fill' },
  BOND:   { label: 'Bond',    color: '#00ff88', icon: 'bi-shield-fill' },
  CRYPTO: { label: 'Crypto',  color: '#aa00ff', icon: 'bi-currency-bitcoin' },
  ALL:    { label: 'Multi',   color: '#889aaa', icon: 'bi-grid-fill' },
};
function AssetTypeBadge({ universe }) {
  const cfg = ASSET_TYPE_CFG[(universe || 'ALL').toUpperCase()] || ASSET_TYPE_CFG.ALL;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '2px 8px', borderRadius: 20,
      fontSize: 10, fontWeight: 700, letterSpacing: 0.4,
      backgroundColor: `${cfg.color}18`, color: cfg.color,
      border: `1px solid ${cfg.color}44`,
    }}>
      <i className={`bi ${cfg.icon}`} style={{ fontSize: 10 }} />{cfg.label}
    </span>
  );
}

// ======================================================
// BOTTOM NAV ITEMS
// ======================================================
const NAV_ITEMS = [
  { key: 'settings',   route: '/settings',     icon: 'bi-gear',            labelKey: 'portfolio.settings' },
  { key: 'ai-advisor', route: '/ai-advisor',   icon: 'bi-stars',           labelKey: 'portfolio.ai_advisor' },
  { key: 'predict',    route: '/predictions',  icon: 'bi-cpu',              labelKey: 'portfolio.predict', isCenter: true },
  { key: 'money',      route: '/manage-money', icon: 'bi-wallet2',          labelKey: 'portfolio.manage_money' },
  { key: 'my-data',    route: '/my-data',      icon: 'bi-person-circle',   labelKey: 'portfolio.my_data' },
];

function BottomNav({ navStyle, navigate, t, onPredictClick }) {
  const wrapStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: SEMANTIC.backgroundApp,
    borderTop: `1px solid rgba(255,255,255,0.08)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: navStyle === 'icon-text' ? '8px 12px 12px' : '10px 12px',
    zIndex: 100,
  };

  return (
    <div style={wrapStyle}>
      {NAV_ITEMS.map((item) => {
        const handleClick = item.isCenter && onPredictClick
          ? onPredictClick
          : () => navigate(item.route);

        if (navStyle === 'text') {
          return (
            <button
              key={item.key}
              onClick={handleClick}
              style={{
                backgroundColor: item.isCenter ? SEMANTIC.ctaPrimary : 'transparent',
                color: item.isCenter ? SEMANTIC.ctaPrimaryText : SEMANTIC.ctaPrimary,
                border: item.isCenter ? 'none' : `2px solid ${SEMANTIC.ctaPrimary}`,
                borderRadius: '50px',
                flex: item.isCenter ? 1.2 : 1,
                margin: '0 6px',
                padding: '12px 0',
                fontWeight: 'bold',
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              {t(item.labelKey)}
            </button>
          );
        }

        if (navStyle === 'icon') {
          if (item.isCenter) {
            return (
              <div key={item.key} onClick={handleClick} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, cursor: 'pointer', flexShrink: 0 }}>
                <button
                  style={{
                    backgroundColor: SEMANTIC.ctaPrimaryText,
                    border: `4px solid ${SEMANTIC.ctaPrimary}`,
                    borderRadius: '50%',
                    width: '68px',
                    height: '68px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0,
                    boxShadow: `0 0 16px rgba(0,255,136,0.25)`,
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/K.png`}
                    alt="Predict"
                    style={{ width: '32px', height: '32px', objectFit: 'contain' }}
                  />
                </button>
                <span style={{ fontSize: '10px', fontWeight: 'bold', color: SEMANTIC.ctaPrimary, whiteSpace: 'nowrap' }}>
                  {t(item.labelKey)}
                </span>
              </div>
            );
          }
          return (
            <button
              key={item.key}
              onClick={handleClick}
              style={{
                background: 'transparent',
                border: 'none',
                color: SEMANTIC.ctaPrimary,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                flex: 1,
              }}
            >
              <i className={`bi ${item.icon}`} style={{ fontSize: '26px' }} />
            </button>
          );
        }

        // icon-text (default)
        if (item.isCenter) {
          return (
            <div key={item.key} onClick={handleClick} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, cursor: 'pointer', flexShrink: 0 }}>
              <button
                style={{
                  backgroundColor: SEMANTIC.ctaPrimaryText,
                  border: `4px solid ${SEMANTIC.ctaPrimary}`,
                  borderRadius: '50%',
                  width: '72px',
                  height: '72px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  flexShrink: 0,
                  boxShadow: `0 0 18px rgba(0,255,136,0.3)`,
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/K.png`}
                  alt="Predict"
                  style={{ width: '36px', height: '36px', objectFit: 'contain' }}
                />
              </button>
              <span style={{ fontSize: '10px', fontWeight: 'bold', color: SEMANTIC.ctaPrimary, whiteSpace: 'nowrap' }}>
                {t(item.labelKey)}
              </span>
            </div>
          );
        }
        return (
          <button
            key={item.key}
            onClick={handleClick}
            style={{
              background: 'transparent',
              border: 'none',
              color: SEMANTIC.ctaPrimary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '3px',
              cursor: 'pointer',
              flex: 1,
              fontSize: '11px',
              fontWeight: 'bold',
            }}
          >
            <i className={`bi ${item.icon}`} style={{ fontSize: '22px' }} />
            {t(item.labelKey)}
          </button>
        );
      })}
    </div>
  );
}

function Portfolio() {
  const [portfolios, setPortfolios] = useState([]);
  const [nickname, setNickname] = useState('');

  const [error, setError] = useState('');
  const [portfolioTypesCount, setPortfolioTypesCount] = useState(0);
  const [alpacaApiKey, setAlpacaApiKey] = useState(undefined); // undefined = not yet fetched
  const [tradingMode, setTradingMode] = useState('paper');
  const [membershipTier, setMembershipTier] = useState(null);
  const [apiKeyInput, setApiKeyInput] = useState('');
  const [secretKeyInput, setSecretKeyInput] = useState('');
  const [apiKeySaving, setApiKeySaving] = useState(false);
  const [apiKeyError, setApiKeyError] = useState('');
  const userId = localStorage.getItem('userId');
  const navigate = useNavigate();
  const _liveIntervalRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [navStyle, setNavStyleState] = useState(getNavStyle());
  const [liveValues, setLiveValues] = useState({});
  const [liveLoaded, setLiveLoaded] = useState(false);
  const { t } = useTranslation();
  const { modal, showModal } = useAppModal();

  // Fetch user profile (nickname + membership + alpaca key)
  const fetchUser = useCallback(async () => {
    try {
      const res = await API.get(`/users/${userId}/profile`);
      setNickname(res.data.nickname);
      setAlpacaApiKey(res.data.alpaca_api_key || null);
      setTradingMode(res.data.trading_mode || 'paper');
      const membershipKey = res.data.membership || 'earth';
      API.get('/membership-tiers')
        .then(r => setMembershipTier((r.data || []).find(t => t.tier_key === membershipKey) || null))
        .catch(() => {});
    } catch (err) {
      console.error('Error fetching user data:', err);
      setError('Failed to fetch user data.');
      setAlpacaApiKey(null);
    }
  }, [userId]);

  const handleSaveApiKey = async () => {
    if (!apiKeyInput.trim() || !secretKeyInput.trim()) {
      setApiKeyError(t('portfolio.apikey_required', 'Inserisci sia l\'API Key che la Secret Key'));
      return;
    }
    setApiKeySaving(true);
    setApiKeyError('');
    try {
      await API.put(`/users/${userId}/alpaca-key`, {
        alpaca_api_key: apiKeyInput.trim(),
        alpaca_secret_key: secretKeyInput.trim(),
      });
      setAlpacaApiKey(apiKeyInput.trim());
      // Dopo aver salvato la chiave, imposta la modalità real trading
      try {
        await API.put(`/users/${userId}/trading-mode`, { trading_mode: 'real' });
      } catch (_) { /* non bloccante */ }
    } catch (err) {
      setApiKeyError(err.response?.data?.error || t('portfolio.apikey_error', 'Errore nel salvataggio'));
    } finally {
      setApiKeySaving(false);
    }
  };

  // Fetch numero tipi di portafoglio
  const fetchPortfolioTypesCount = useCallback(async () => {
    try {
      const res = await axios.get('/api/tipo_portafoglio');
      const arr = Array.isArray(res.data) ? res.data : [];
      setPortfolioTypesCount(arr.length);
    } catch (err) {
      console.error('Error fetching portfolio types:', err);
      setPortfolioTypesCount(0);
    }
  }, []);

  // Fetch all portfolios for the user
  const fetchPortfolios = useCallback(async () => {
    try {
      const res = await API.get(`/portfolios/${userId}`);
      const portfoliosData = res.data.portfolios || [];

      const PENDING_STATUSES = ['created', 'submitted', 'queued', 'new', 'partial', 'accepted', 'pending_new'];

      const enrichedPortfolios = await Promise.all(
        portfoliosData.map(async (p) => {
          const [tickersRes, ordersRes] = await Promise.allSettled([
            API.get(`/portfolio/${p.id}/tickers`),
            API.get(`/portfolio/${p.id}/orders`),
          ]);

          const tickers = tickersRes.status === 'fulfilled' ? (tickersRes.value.data.tickers || []) : [];
          const allOrders = ordersRes.status === 'fulfilled' ? (ordersRes.value.data.orders || []) : [];
          const pendingOrders = allOrders.filter(o => PENDING_STATUSES.includes(o.status));

          return { ...p, tickers, pendingOrders };
        })
      );

      setPortfolios(enrichedPortfolios);
      localStorage.setItem('portfolioCount', enrichedPortfolios.length);
    } catch (err) {
      console.error('Error fetching portfolios:', err);
      setError('No portfolios found. Please create one.');
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      Promise.all([
        fetchUser(),
        fetchPortfolioTypesCount(),
        fetchPortfolios(),
      ]).finally(() => {
        setLoading(false);
      });
    } else {
      navigate('/');
    }
  }, [userId, navigate, fetchUser, fetchPortfolios, fetchPortfolioTypesCount]);

  // Fetch prezzi live da Alpaca per tutti i portafogli visibili
  const fetchLiveValues = useCallback(async (pfList) => {
    if (!pfList || pfList.length === 0) return;
    const results = await Promise.allSettled(
      pfList.map(p => API.get(`/portfolio/${p.id}/live-value`))
    );
    setLiveValues(prev => {
      const next = { ...prev };
      pfList.forEach((p, i) => {
        if (results[i].status === 'fulfilled') {
          next[p.id] = results[i].value.data;
        }
      });
      return next;
    });
    setLiveLoaded(true);
  }, []);

  useEffect(() => {
    if (portfolios.length === 0) return;
    fetchLiveValues(portfolios);

    let cancelled = false;
    API.get('/admin/config/portfolio-refresh-interval/public')
      .then(res => {
        if (cancelled) return;
        const secs = res.data?.interval ?? 60;
        if (secs <= 0) return;
        _liveIntervalRef.current = setInterval(() => fetchLiveValues(portfolios), secs * 1000);
      })
      .catch(() => {
        if (cancelled) return;
        _liveIntervalRef.current = setInterval(() => fetchLiveValues(portfolios), 60000);
      });

    return () => {
      cancelled = true;
      if (_liveIntervalRef.current) { clearInterval(_liveIntervalRef.current); _liveIntervalRef.current = null; }
    };
  }, [portfolios, fetchLiveValues]); // eslint-disable-line

  // Aggiorna navStyle quando l'utente torna dalla pagina Settings
  useEffect(() => {
    const onFocus = () => setNavStyleState(getNavStyle());
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);


  const visiblePortfolios = portfolios.filter(
    p => (p.trading_mode || 'paper') === tradingMode
  );

  const totalBalance = visiblePortfolios.reduce(
    (sum, p) => sum + (liveValues[p.id] ? liveValues[p.id].total_balance : Number(p.total_balance || 0)),
    0
  );

  const totalInvested = visiblePortfolios.reduce((sum, p) => {
    const invested = p.net_invested != null
      ? Number(p.net_invested)
      : Number(p.budget || 0);
    return sum + invested;
  }, 0);

  const totalGrowth =
    totalInvested > 0 ? ((totalBalance - totalInvested) / totalInvested) * 100 : 0;

  const totalLiquidity = visiblePortfolios.reduce(
    (sum, p) => sum + (liveValues[p.id] ? liveValues[p.id].liquidity : Number(p.liquidity || 0)), 0
  );
  const totalAssets = visiblePortfolios.reduce(
    (sum, p) => sum + (liveValues[p.id] ? liveValues[p.id].asset_value : (p.tickers || []).reduce(
      (s, tk) => s + Number(tk.quantity || 0) * Number(tk.last_price || tk.purchase_price || 0),
      0
    )), 0
  );

  // Il paper trading usa il profilo Saturn: nessun limite di portafogli
  const canAddNew = visiblePortfolios.length < portfolioTypesCount &&
    (tradingMode === 'paper' || membershipTier?.max_portfolios == null || visiblePortfolios.length < (membershipTier?.max_portfolios || Infinity));

  const handlePortfolioClick = (portfolioId) => {
    localStorage.setItem('portfolioId', portfolioId);
    navigate('/portfolio-details');
  };

  const handlePredictClick = () => {
    if (portfolios.length === 0) {
      showModal({
        type: 'info',
        title: t('portfolio.predict_no_portfolio_title'),
        message: t('portfolio.predict_no_portfolio_body'),
        confirmLabel: t('portfolio.predict_no_portfolio_cta'),
        onConfirm: () => navigate('/select-portfolio-type'),
      });
    } else {
      navigate('/predictions');
    }
  };

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: SEMANTIC.backgroundApp,
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: SEMANTIC.textPrimary,
          fontSize: '1.2rem',
        }}
      >
        {t('portfolio.loading')}
      </div>
    );
  }

  // ── API Key CTA ─────────────────────────────────────────────────────────────
  // Mostra solo in real trading e solo se la chiave non è ancora stata inserita
  if (tradingMode === 'real' && alpacaApiKey === null) {
    return (
      <div style={{
        backgroundColor: SEMANTIC.backgroundApp,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
      }}>
        <img
          src={`${process.env.PUBLIC_URL}/Logo_Kuesto.png`}
          alt="Kuesto"
          style={{ width: 100, marginBottom: 32 }}
        />

        <div style={{
          backgroundColor: SEMANTIC.backgroundCard,
          borderRadius: '16px',
          padding: '36px 32px',
          maxWidth: 440,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          border: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔑</div>
          <h2 style={{
            color: SEMANTIC.textPrimary,
            fontSize: 22,
            fontWeight: 700,
            marginBottom: 10,
          }}>
            {t('portfolio.apikey_title', 'Inserisci la tua API Key Alpaca')}
          </h2>
          <p style={{
            color: SEMANTIC.textSecondary,
            fontSize: 14,
            lineHeight: 1.6,
            marginBottom: 28,
          }}>
            {t('portfolio.apikey_subtitle', 'Per attivare il Real Trading collega il tuo account Alpaca. Trovi le chiavi nella dashboard Alpaca sotto "API Keys".')}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 }}>
            <input
              type="text"
              value={apiKeyInput}
              onChange={e => setApiKeyInput(e.target.value)}
              placeholder={t('portfolio.apikey_placeholder', 'API Key (es. PKxxxxxxxxxxxxxxx)')}
              autoComplete="off"
              style={{
                padding: '12px 14px',
                borderRadius: 8,
                backgroundColor: '#0d0d22',
                border: '1px solid #334',
                color: SEMANTIC.textPrimary,
                fontSize: 14,
                outline: 'none',
                fontFamily: 'monospace',
              }}
            />
            <input
              type="password"
              value={secretKeyInput}
              onChange={e => setSecretKeyInput(e.target.value)}
              placeholder={t('portfolio.secretkey_placeholder', 'Secret Key')}
              autoComplete="off"
              style={{
                padding: '12px 14px',
                borderRadius: 8,
                backgroundColor: '#0d0d22',
                border: '1px solid #334',
                color: SEMANTIC.textPrimary,
                fontSize: 14,
                outline: 'none',
                fontFamily: 'monospace',
              }}
            />
          </div>

          {apiKeyError && (
            <div style={{
              color: SEMANTIC.actionSell,
              fontSize: 13,
              marginBottom: 12,
              padding: '8px 12px',
              backgroundColor: 'rgba(255,77,77,0.1)',
              borderRadius: 6,
              border: '1px solid rgba(255,77,77,0.25)',
            }}>
              {apiKeyError}
            </div>
          )}

          <button
            onClick={handleSaveApiKey}
            disabled={apiKeySaving}
            style={{
              width: '100%',
              padding: '13px 0',
              backgroundColor: apiKeySaving ? 'rgba(0,255,136,0.08)' : SEMANTIC.ctaPrimary,
              color: apiKeySaving ? '#445' : SEMANTIC.ctaPrimaryText,
              border: 'none',
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 700,
              cursor: apiKeySaving ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s',
            }}
          >
            {apiKeySaving
              ? t('portfolio.apikey_saving', 'Salvataggio...')
              : t('portfolio.apikey_save', 'Collega account Alpaca')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <style>{`
      @keyframes livePulse {
        0%, 100% { opacity: 1; box-shadow: 0 0 6px ${SEMANTIC.actionBuy}; transform: scale(1); }
        50%       { opacity: 0.4; box-shadow: 0 0 12px ${SEMANTIC.actionBuy}; transform: scale(1.3); }
      }
    `}</style>
    <div
      style={{
        backgroundColor: SEMANTIC.backgroundApp,
        color: SEMANTIC.textPrimary,
        minHeight: '100vh',
        padding: '20px',
        paddingBottom: '120px',
      }}
    >
      {/* Header: trading mode badge */}
      <div className="d-flex justify-content-start align-items-center mb-4">
        {(() => {
          const isReal = tradingMode === 'real';
          return (
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 0.6,
              padding: '5px 12px',
              borderRadius: 20,
              backgroundColor: isReal ? 'rgba(0,170,255,0.12)' : 'rgba(0,255,136,0.1)',
              color: isReal ? '#00aaff' : '#00ff88',
              border: `1px solid ${isReal ? 'rgba(0,170,255,0.4)' : 'rgba(0,255,136,0.3)'}`,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/settings')}
            title="Cambia modalità in Impostazioni"
            >
              {isReal ? '🏦' : '🧪'} {isReal ? 'Real Trading' : 'Paper Trading'}
            </span>
          );
        })()}
      </div>

      {error && <p className="alert alert-danger">{error}</p>}

      {canAddNew && (
        <div className="text-center mb-4">
          <button
            onClick={() => navigate('/select-portfolio-type')}
            style={{
              backgroundColor: SEMANTIC.ctaPrimary,
              color: SEMANTIC.ctaPrimaryText,
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '50px',
              padding: '12px 30px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.7)',
              cursor: 'pointer',
              fontSize: '15px',
            }}
          >
            {t('portfolio.add_new')}
          </button>
        </div>
      )}

      {visiblePortfolios.length > 0 ? (
        <div>
          {/* SUMMARY CARD */}
          <div
            className="card mb-4"
            onClick={() => navigate(`/performance?mode=${tradingMode}`)}
            style={{
              backgroundColor: SEMANTIC.backgroundCard,
              color: SEMANTIC.textPrimary,
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              border: `1px solid ${SEMANTIC.actionBuy}`,
              borderRadius: '14px',
              cursor: 'pointer',
              transition: 'transform 0.2s ease-in-out',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            <div className="card-body">

              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 18 }}>📊</span>
                  <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.5, color: SEMANTIC.actionBuy }}>
                    {nickname
                      ? t('portfolio.value_title_user', { nickname })
                      : t('portfolio.value_title')}
                  </span>
                </div>
                <i className="bi bi-bar-chart-line" style={{ color: SEMANTIC.textSecondary, fontSize: 14 }} />
              </div>

              {/* Valore totale + crescita */}
              <div style={{ textAlign: 'center', marginBottom: 12 }}>
                <div style={{ fontSize: 32, fontWeight: 800, color: SEMANTIC.textPrimary }}>
                  {liveLoaded
                    ? `$${Number(totalBalance || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : <span style={{ color: SEMANTIC.textSecondary, fontSize: 24 }}>—</span>}
                </div>
                {Object.keys(liveValues).length > 0 && (
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4, marginBottom: 2 }}>
                    <span style={{
                      width: 7, height: 7, borderRadius: '50%',
                      backgroundColor: SEMANTIC.actionBuy,
                      display: 'inline-block',
                      animation: 'livePulse 1.8s ease-in-out infinite',
                    }} />
                    <span style={{ fontSize: 10, color: SEMANTIC.actionBuy, fontWeight: 'bold', letterSpacing: 0.5 }}>
                      LIVE
                    </span>
                  </div>
                )}
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4,
                  fontSize: 14, fontWeight: 700,
                  color: totalGrowth >= 0 ? SEMANTIC.actionBuy : SEMANTIC.actionSell,
                }}>
                  <i className={`bi ${totalGrowth >= 0 ? 'bi-arrow-up' : 'bi-arrow-down'}`} />
                  {Math.abs(totalGrowth).toFixed(2)}%
                </div>
              </div>

              {/* Split: Asset | Liquidità */}
              <div style={{
                display: 'flex', alignItems: 'stretch',
                backgroundColor: SEMANTIC.backgroundApp,
                borderRadius: 10, overflow: 'hidden',
                border: `1px solid ${SEMANTIC.backgroundDisabled}`,
                marginBottom: 12,
              }}>
                <div style={{ flex: 1, padding: '12px 16px', textAlign: 'center' }}>
                  <div style={{ fontSize: 11, color: SEMANTIC.textSecondary, marginBottom: 4, fontWeight: 600, letterSpacing: 0.4 }}>
                    <i className="bi bi-graph-up" style={{ marginRight: 5, color: SEMANTIC.actionBuy }} />
                    {t('portfolio.alpaca_tile_assets')}
                  </div>
                  <div style={{ fontSize: 17, fontWeight: 700, color: SEMANTIC.actionBuy }}>
                    ${totalAssets.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>

                <div style={{ width: 1, backgroundColor: SEMANTIC.backgroundDisabled }} />

                <div style={{ flex: 1, padding: '12px 16px', textAlign: 'center' }}>
                  <div style={{ fontSize: 11, color: SEMANTIC.textSecondary, marginBottom: 4, fontWeight: 600, letterSpacing: 0.4 }}>
                    <i className="bi bi-cash" style={{ marginRight: 5, color: SEMANTIC.actionHold }} />
                    {t('portfolio.alpaca_tile_liquidity')}
                  </div>
                  <div style={{ fontSize: 17, fontWeight: 700, color: SEMANTIC.actionHold }}>
                    ${totalLiquidity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </div>
                </div>
              </div>

              {/* Footer: totale investito */}
              <div style={{ textAlign: 'center', color: SEMANTIC.textSecondary, fontSize: 12 }}>
                {t('portfolio.total_invested', {
                  amount: Number(totalInvested).toFixed(2),
                  count: visiblePortfolios.length,
                })}
              </div>

            </div>
          </div>

          {/* PORTFOLIO CARDS */}
          {visiblePortfolios.map((portfolio) => {
            const live = liveValues[portfolio.id];
            const totalBalanceValue = liveLoaded
              ? (live ? live.total_balance : Number(portfolio.total_balance || 0))
              : null;
            const liquidityValue = liveLoaded
              ? (live ? live.liquidity : Number(portfolio.liquidity || 0))
              : null;

            const growth = (() => {
              const net = portfolio.net_invested != null
                ? Number(portfolio.net_invested)
                : Number(portfolio.budget || 0);
              if (net === 0) return 0;
              return ((totalBalanceValue - net) / net) * 100;
            })();

            const assetsValue = liveLoaded
              ? (live ? live.asset_value : (portfolio.tickers || []).reduce(
                  (total, t) =>
                    total + Number(t.quantity || 0) * Number(t.last_price || t.purchase_price || 0),
                  0
                ))
              : null;

            const investedValue = portfolio.net_invested != null
              ? Number(portfolio.net_invested)
              : Number(portfolio.budget || 0);

            return (
              <div
                key={portfolio.id}
                className="card mb-4"
                onClick={() => handlePortfolioClick(portfolio.id)}
                style={{
                  backgroundColor: SEMANTIC.backgroundCard,
                  color: SEMANTIC.textPrimary,
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.7)',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease-in-out',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              >
                <div className="card-body">

                  {/* Header */}
                  <div
                    className="d-flex justify-content-between align-items-start mb-2"
                    style={{
                      borderBottom: '1px solid #333',
                      paddingBottom: '8px',
                    }}
                  >
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <h5
                          className="card-title"
                          style={{ margin: 0, color: SEMANTIC.actionBuy, fontWeight: '600' }}
                        >
                          {t('portfolio.card_title', { name: portfolio.Nome_tipo_modello || `Tipo ${portfolio.tipo_id}` })}
                        </h5>
                        <AssetTypeBadge universe={portfolio.ticker_universe} />
                      </div>

                      <p
                        style={{
                          fontSize: '0.9rem',
                          color: '#ccc',
                          margin: '4px 0 0',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                        }}
                      >
                        <i className="bi bi-calendar3" style={{ color: '#00aaff' }}></i>
                        {portfolio.created_at
                          ? new Date(portfolio.created_at).toLocaleDateString()
                          : 'N/A'}
                        <span style={{ marginLeft: '6px' }}>
                          {t('portfolio.card_invested')}{' '}
                          <i className="bi bi-cash-stack" style={{ color: SEMANTIC.actionBuy, marginRight: '4px' }}></i>
                          ${investedValue.toFixed(2)}
                        </span>
                      </p>
                    </div>

                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#ffffff' }}>
                        {totalBalanceValue !== null ? `$${totalBalanceValue.toFixed(2)}` : '—'}
                      </div>
                      <p
                        style={{
                          color: growth >= 0 ? SEMANTIC.actionBuy : SEMANTIC.actionSell,
                          fontSize: '0.9rem',
                          margin: 0,
                        }}
                      >
                        {totalBalanceValue !== null ? `${growth.toFixed(2)}%` : '—'}
                      </p>
                    </div>
                  </div>

                  {/* Liquidity and assets */}
                  <p className="mt-3 mb-2">
                    {liquidityValue !== null
                      ? t('portfolio.liquidity_assets', {
                          liquidity: liquidityValue.toFixed(2),
                          assets: assetsValue !== null ? assetsValue.toFixed(2) : '—',
                        })
                      : '—'}
                  </p>

                  {/* Tickers grid */}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '10px',
                    }}
                  >
                    {portfolio.tickers && portfolio.tickers.length > 0 ? (
                      (() => {
                        const livePriceMap = {};
                        if (live && live.positions) {
                          live.positions.forEach(pos => {
                            if (pos.price != null) livePriceMap[pos.symbol] = pos.price;
                          });
                        }
                        return portfolio.tickers.map((ticker, i) => {
                          const livePrice = livePriceMap[ticker.ticker];
                          const displayPrice = livePrice ?? ticker.last_price;
                          const formattedDate = !livePrice && ticker.last_price_date
                            ? new Date(ticker.last_price_date).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' })
                            : '';

                          return (
                            <div
                              key={i}
                              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/ticker/${ticker.ticker}`);
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/logos/${ticker.ticker}.png`}
                                alt={`${ticker.ticker} logo`}
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  marginRight: '10px',
                                  borderRadius: '10%',
                                  border: '1px solid #ccc',
                                  objectFit: 'contain',
                                  backgroundColor: '#f9f9f9',
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = `${process.env.PUBLIC_URL}/logos/default-logo.png`;
                                }}
                              />

                              <div>
                                <strong>{ticker.ticker}</strong>
                                {ticker.long_name && (
                                  <span style={{ color: SEMANTIC.textSecondary, fontSize: '11px', marginLeft: '6px' }}>
                                    {ticker.long_name}
                                  </span>
                                )}
                                <br />
                                <span>
                                  {t('portfolio.ticker_invested', { qty: ticker.quantity, price: Number(ticker.purchase_price).toFixed(2) })}
                                </span><br />
                                <span style={{ color: Number(displayPrice) >= Number(ticker.purchase_price) ? SEMANTIC.actionBuy : SEMANTIC.actionSell }}>
                                  {t('portfolio.ticker_last', { price: Number(displayPrice).toFixed(2) })}
                                  {livePrice
                                    ? <span style={{ fontSize: 9, marginLeft: 4, opacity: 0.8 }}>{t('portfolio.ticker_live_label')}</span>
                                    : (formattedDate ? ` (${formattedDate})` : '')}
                                </span>
                              </div>
                            </div>
                          );
                        });
                      })()
                    ) : (
                      <p>{t('portfolio.no_tickers')}</p>
                    )}
                  </div>

                  {/* Pending orders */}
                  {portfolio.pendingOrders && portfolio.pendingOrders.length > 0 && (() => {
                    const tickerPriceMap = {};
                    (portfolio.tickers || []).forEach(tk => {
                      tickerPriceMap[tk.ticker] = Number(tk.last_price || tk.purchase_price || 0);
                    });
                    if (live && live.positions) {
                      live.positions.forEach(pos => {
                        if (pos.price != null) tickerPriceMap[pos.symbol] = pos.price;
                      });
                    }

                    const symbols = [...new Set(portfolio.pendingOrders.map(o => o.symbol))];
                    const allocated = portfolio.pendingOrders.reduce((sum, o) => {
                      const price = o.limit_price != null
                        ? Number(o.limit_price)
                        : (tickerPriceMap[o.symbol] || 0);
                      return sum + Number(o.quantity || 0) * price;
                    }, 0);

                    return (
                      <div
                        style={{
                          marginTop: '12px',
                          padding: '8px 12px',
                          backgroundColor: 'rgba(255, 170, 0, 0.08)',
                          border: '1px solid rgba(255, 170, 0, 0.35)',
                          borderRadius: '6px',
                          fontSize: '0.82rem',
                          color: '#ffaa00',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <i className="bi bi-hourglass-split"></i>
                        <span>
                          <strong>Pending orders:</strong>{' '}
                          {symbols.join(', ')}
                          {allocated > 0 ? ` allocated $${allocated.toFixed(2)}` : ''}
                        </span>
                      </div>
                    );
                  })()}

                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center">
          <p>{t('portfolio.no_portfolios')}</p>
        </div>
      )}

      {/* Bottom Buttons */}
      <BottomNav navStyle={navStyle} navigate={navigate} t={t} onPredictClick={handlePredictClick} />
      {modal}
    </div>
    </>
  );
}

export default Portfolio;
